module.exports = __webpack_public_path__ + "media/coffee-preferences/adventurousness_medium-ae6288e9.png";